import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Card({ children, className = '', noPadding = false, interactive = false, onClick, }) {
    return (_jsx("div", { onClick: onClick, role: onClick ? 'button' : undefined, tabIndex: onClick ? 0 : undefined, onKeyDown: onClick
            ? (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick(e);
                }
            }
            : undefined, className: [
            'rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800',
            noPadding ? '' : 'p-6',
            interactive
                ? 'cursor-pointer transition-shadow duration-150 hover:shadow-md active:shadow-sm'
                : '',
            className,
        ]
            .filter(Boolean)
            .join(' '), children: children }));
}
export function CardHeader({ title, subtitle, action, as: Heading = 'h2' }) {
    return (_jsxs("div", { className: "mb-4 flex items-start justify-between gap-4", children: [_jsxs("div", { children: [_jsx(Heading, { className: "text-lg font-semibold text-balance text-gray-900 dark:text-gray-100", children: title }), subtitle && (_jsx("p", { className: "mt-0.5 text-sm text-pretty text-gray-500 dark:text-gray-400", children: subtitle }))] }), action && _jsx("div", { className: "shrink-0", children: action })] }));
}
//# sourceMappingURL=Card.js.map